const playVideo = () => {
    const playVideo = document.getElementById('js-play-video')
    const videoSrc = document.querySelector('.video-origin iframe')
    const videoHolder=  document.getElementById("video-holder")
    if(playVideo){
        playVideo.addEventListener('click', ev => {
            ev.preventDefault()
            let ifrm = document.createElement("iframe")
            let srcIfrm = videoSrc.getAttribute('src')
            ifrm.setAttribute("src", srcIfrm+'?autoplay=1')
            //ifrm.setAttribute("allow", "autoplay")
            ifrm.setAttribute("allowfullscreen","")
            playVideo.classList.remove('z-10')
            playVideo.classList.add('opacity-0','-z-[1]')
            ifrm.frameborder = 0
            videoHolder.classList.add('opacity-1','z-[10]')
            videoHolder.appendChild(ifrm)  //append it to your parent div 
            return false;
        })
    }
}
export default playVideo;